import { RichTextField, RTInlineNode } from '@prismicio/client'
import { FooterDocument } from '../../prismicio-types'
import { asHTML } from '@prismicio/client'
import styles from './Footer.module.css'
import linkResolver from '../linkResolver'

export class Footer {
	static render(props: FooterDocument) {
		const {
			data: { copyright, items_left, items_right }
		} = props

		type Item = RichTextField & [{ spans: RTInlineNode[] }]

		function Item(item: Item) {
			let isExternal = false
			if (item[0].spans[0]?.type === 'hyperlink') {
				if (item[0].spans[0]?.data?.link_type === 'Web' && !item[0].spans[0]?.data?.url.includes('mailto:')) {
					isExternal = true
				}
			}

			return `<div class="${isExternal ? styles.IsExternal : ''}">${asHTML(item, { linkResolver })}</div>`
		}

		return /* HTML */ `
			<footer class="${styles.Main}">
				<div class="${styles.Inner}">
					<div class="${styles.Copyright}">${copyright}</div>
					<div class="${styles.Bottom}">
						<div class="${styles.Items}">${items_left.map(({ item }) => Item(item as Item)).join('')}</div>
						<div class="${styles.Items} ${styles.AlignRight}">
							${items_right.map(({ item }) => Item(item as Item)).join('')}
						</div>
					</div>
				</div>
			</footer>
		`
	}
}
